import { SubtitleProps } from './Types'
import Styles from './Subtitle.module.scss'

const Subtitle = ({ children }: SubtitleProps) => {
  return <div className={Styles.subtitle}>{children}</div>
}

export { Subtitle }
